import React, {Component} from 'react';
import {FastLayer, Image} from 'react-konva';

/** @class PatternLayer
  * A layer sized to the stage that consists of a repeated
  * (tiled) image pattern.
  */
export default class PatternLayer extends Component {
  /** @constructor
    * Creates a new instance of PatternLayer
    * @prop {url} image - the image to repeat
    * @prop {number} width - the width of the stage to cover in pixels
    * @prop {number} height - the height of the stage to cover in pixels
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
  }
  /** @method componentDidMount
    * Loads the pattern image.
    */
  componentDidMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
    }
    image.src = this.props.image;
  }
  /** @method render
    * Renders the component.
    */
  render() {
    return (
      <FastLayer>
        <Image
          width={this.props.width}
          height={this.props.height}
          fillPatternImage={this.state.image}
          fillPatternRepeat="repeat"
          transformsEnabled="position"
          />
      </FastLayer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/stage/pattern-layer.js